export default {
  brandClasses: 'bg-white'
}
